import Joi from 'joi';

import { phoneSchema } from '../../../../shared/validators/schemas/phone.schema';

/**
 * Schema for contact validation when creating a new tenant contact.
 * @returns {Joi.ObjectSchema} - A Joi object schema for creating a tenant contact.
 */
export const createTenantContactSchema = () =>
	Joi.object({
		id: Joi.valid(null).required().messages({
			'any.required': 'validations|contact-id|must-be-null',
			'any.only': 'validations|contact-id|must-be-null',
		}),

		county: Joi.string().allow(null).messages({
			'string.base': 'validations|contact-county|must-be-string',
		}),

		state: Joi.string().allow(null).messages({
			'string.base': 'validations|contact-state|must-be-string',
		}),

		countryId: Joi.number().allow(null).messages({
			'number.base': 'validations|contact-country-id|must-be-number',
		}),

		address1: Joi.string().allow(null).messages({
			'string.base': 'validations|contact-address1|must-be-string',
		}),

		address2: Joi.string().allow(null).messages({
			'string.base': 'validations|contact-address2|must-be-string',
		}),

		city: Joi.string().allow(null).messages({
			'string.base': 'validations|contact-city|must-be-string',
		}),

		postCode: Joi.string().allow(null).messages({
			'string.base': 'validations|contact-post-code|must-be-string',
		}),

		phoneLandline: phoneSchema().allow(null).messages({
			'string.pattern.base': 'validations|contact-phone-landline|invalid',
			'string.base': 'validations|contact-phone-landline|must-be-string',
		}),

		phoneMobile: phoneSchema().allow(null).messages({
			'string.pattern.base': 'validations|contact-phone-mobile|invalid',
			'string.base': 'validations|contact-phone-mobile|must-be-string',
		}),

		phoneFax: phoneSchema().allow(null).messages({
			'string.pattern.base': 'validations|contact-phone-fax|invalid',
			'string.base': 'validations|contact-phone-fax|must-be-string',
		}),

		poBox: Joi.string().allow(null).messages({
			'string.base': 'validations|contact-po-box|must-be-string',
		}),
	})
		// Ignore extra fields
		.unknown();
